import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class ProductoMarcaService {

  API_URI = environment.API_URL;
  constructor(private http: HttpClient) { }

  getCMarcas(){
    return this.http.get(`${this.API_URI}/productos-marcas`)
  }

  getMarca(id:string){
    return this.http.get(`${this.API_URI}/productos-marcas/${id}`);
  }

  actualizarMarca(id: string | number, datos: any): Observable<any> {
    return this.http.put(`${this.API_URI}/productos-marcas/${id}`, datos);
  }
  
  crearMarca(datos: any) {
    return this.http.post(`${this.API_URI}/productos-marcas`, datos);
  }

  eliminarMarca(id: string): Observable<any> {
    return this.http.delete(`${this.API_URI}/productos-marcas/${id}`);
  }

  actualizarEstadoImagen(id: string | number, datos: any): Observable<any> {
    return this.http.put(`${this.API_URI}/productos-marcas/imagen/${id}`, datos);
  }

}
